import ProductsPage from './ProductsPage';

export default ProductsPage;



// WEBPACK FOOTER //
// ./src/components/ProductsPage/index.js